import React from "react"
import Container from "../../atoms/Container"
import "./Kennismaken.css"
import PrimaryButton from "../../atoms/Buttons/PrimaryButton"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function Kennismaken({ block }) {
  const image = getImage(
    block.afbeelding.localFile.childImageSharp.gatsbyImageData
  )
  return (
    <div className="vt-kennismaken-achtergrond">
      <Container>
        <div className="vt-kennismaken-container">
          <div className="vt-kennismaken-inner-content">
            <GatsbyImage
              className="vt-kennismaken-afbeelding"
              image={image}
              objectFit="contain"
              imgStyle={{ objectFit: "contain" }}
            />
          </div>

          <div className="vt-kennismaken-inner">
            <h5>{block.subtitel}</h5>
            <h2>{block.titel}</h2>
            <div dangerouslySetInnerHTML={{ __html: block.tekst }}></div>
            <PrimaryButton
              label={block.cta.label}
              color={"red"}
              target={block.cta.link}
            />
          </div>
        </div>
      </Container>
    </div>
  )
}
